const compareBuild = require('./compare-build')
const rsort = (list, loose) => list.sort((a, b) => compareBuild(b, a, loose))
module.exports = rsort



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/rsort.js
// module id = 1419
// module chunks = 0